import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const { LOADING_QUESTIONS } = require("constants/loadingQuestions");

const INTERVAL_DURATION = 7500;
const getRandomQuestion = () => {
    return LOADING_QUESTIONS[
        Math.floor(Math.random() * LOADING_QUESTIONS.length)
    ];
};

export default function RandomQuestions({ title }) {
    const [question, setQuestion] = useState("");
    useEffect(() => {
        setQuestion(getRandomQuestion());
        const interval = setInterval(() => {
            setQuestion((prev) => {
                let next = getRandomQuestion();
                while (next === prev) {
                    next = getRandomQuestion();
                }
                return next;
            });
        }, INTERVAL_DURATION);

        return () => clearInterval(interval);
    }, []);
    return (
        <Box px={3} sx={{width: '100%', textAlign: 'center'}}>
            <Typography
                variant="h6"
                component="h3"
                my={2}
                sx={{ fontWeight: 500 }}
            >
                {title}
            </Typography>
            <Typography
                variant="body1"
                component="p"
                mb={3}
                sx={{ fontStyle: "italic" }}
            >
                {question}
            </Typography>
        </Box>
    );
}
